import { factory } from "../../../../utils/apiThunkFactory";

export const getAllChairsByMap = factory.get("chairs/getChairs", "/api/chairs/map/:map_id");

export const occupyChair = factory.post(
  "chairs/occupyChair",
  "/api/placement/chair",
);
